// ServicesSection.js
import React, { useState, useEffect } from 'react';
import './ServicesSection.css';

const ServicesSection = () => {
  const [index, setIndex] = useState(0);
  const cardWidth = 270; // width + margin
  const services = [
    { img: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600&h=400&fit=crop', alt: 'Fashion', title: 'Fashion' },
    { img: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop', alt: 'Healthcare', title: 'Healthcare' },
    { img: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=600&h=400&fit=crop', alt: 'Cosmetics', title: 'Cosmetics' },
    { img: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=600&h=400&fit=crop', alt: 'Logistics', title: 'Logistics' },
    { img: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop', alt: 'Finance', title: 'Finance' },
    { img: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=600&h=400&fit=crop', alt: 'Hospitality', title: 'Hospitality' },
    { img: 'https://images.unsplash.com/photo-1522206024047-9c925421675b?w=600&h=400&fit=crop', alt: '& Expanding', title: '& Expanding' },
  ];

  const slideLeft = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const slideRight = () => {
    if (index < services.length - 3) {
      setIndex(index + 1);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (index < services.length - 3) {
        slideRight();
      } else {
        setIndex(0);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [index, services.length]);

  return (
    <section className="home-services-section">
      <div className="home-services-left">
        <h2>We Service</h2>
        <h3>Specialized Teams. Global Expertise</h3>
        <p>
                     From fashion and e-commerce to finance and technology, our skilled professionals deliver exceptional results across diverse industries with precision and innovation.

        </p>
      </div>

 <div className="home-services-slider-container">
      
      {/* Slider Track */}
      <div
        className="home-services-slider-track"
        style={{ transform: `translateX(-${index * cardWidth}px)` }}
      >
        {services.map((service, idx) => (
          <div key={idx} className="home-services-service-card">
            <img src={service.img} alt={service.alt} />
            <h4>{service.title}</h4>
          </div>
        ))}
      </div>

      {/* Dots Navigation */}
      <div className="home-services-dots">
        {services.map((_, dotIndex) => (
          <span
            key={dotIndex}
            className={`dot ${index === dotIndex ? "active" : ""}`}
            onClick={() => setIndex(dotIndex)}
          ></span>
        ))}
      </div>

    </div>
    </section>
  );
};

export default ServicesSection;